/**
 * @module select
 * @since 1.3.0
 */

/**
 * Filter object keys based on a predicate function, and return a shallow copy of it.
 *
 * @param  {Object} original The object to filter.
 * @param  {Function} condition Predicate function, accepting key-value as parameters and returning a boolean.
 * @return {Object} The filtered object.
 *
 * @example select({a:1, b:2, c:3, d:4}, (key, val) => val > 2);
 * // {c:3, d:4}
 */
export function select(original, condition = () => false) {
    const result = {};

    for (const key in original) {
        if (condition(key, original[key])) {
            result[key] = original[key];
        }
    }

    return result;
}
